import React from 'react'
import { 
    ArtefactsContainer, 
    ArtefactCard,
    ArtefactWrapper,
    ArtefactsHeading,
    ArtefactsHeading1,
    Title, 
    Desc, 
    ArtefactInfo,
    ArtefactImg
} from './BidayuhArtefacts';

import '../../../../App.css';
import {useState} from 'react'; 
import {GiCeremonialMask} from 'react-icons/gi';
import {AiOutlineSearch} from 'react-icons/ai';
import { BidayuhTraditionalCeremonies } from './data';


const BidayuhCeremonies = (props)=> {

    const [searchTerm, setSearchTerm] = useState ("");

    return (
            <ArtefactsContainer> 
            
                <ArtefactsHeading> Bidayuh Traditional Ceremonies </ArtefactsHeading>
                        <label className = "label"> <AiOutlineSearch/> Filter Arterfect </label>
                        <input className = "searchbox"
                            type = "text"
                            placeholder= " Unwrap your heritage " 
                            onChange = {(event) => {
                                setSearchTerm(event.target.value);
                            }}
                        />
                   
                    <ArtefactsHeading1> 
                        <GiCeremonialMask/> Traditional Ceremonies
                    </ArtefactsHeading1>

                    <ArtefactWrapper> 
                        {BidayuhTraditionalCeremonies.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
            </ArtefactsContainer>
    );
};

export default BidayuhCeremonies
